import Browser from '@mindful-web/marko-web/browser';
import Shared from '@watt-global-media/package-global/browser';
import TopCompanies from '@watt-global-media/package-top-companies/browser';

Shared(Browser);
TopCompanies(Browser);

export default Browser;
